import VJsoneditor from './VJsoneditor';

VJsoneditor.install = function install(Vue) {
  Vue.component(VJsoneditor.name, VJsoneditor);
};

export default VJsoneditor;



// WEBPACK FOOTER //
// ./src/components/VJsoneditor/index.js